module.exports = __webpack_public_path__ + "static/chadf-6f60fb7db966eebee42482f2774d70ba.png";